import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';

// Feature Modules
import { ImportsModule } from '../shared/imports/imports.module';
import { VisorModule } from './modules/visor/visor.module';
import { DiagnosticadorVisorModule } from './modules/diagnosticador-visor/Diagnosticadorvisor.module';
import { CarteraModule } from './modules/cartera/cartera.module';
import { SuperadminModule } from './modules/superadmin/superadmin.module';
import { CuotasModule } from './modules/cuotas/cuotas.module';
import { ParametrizacionModule } from './modules/parametrizacion/parametrizacion.module';
import { LogisticaModule } from './modules/logistica/logistica.module';
import { VentayaModule } from './modules/ventaya/ventaya.module';
import { ComisionesdevendedoresModule } from './modules/comisionesdevendedores/comisionesdevendedores.module';
import { AdminDashboardComponent } from './components/dashboard/dashboard.component';
import { CreditoModule } from './modules/credito/credito.module';
import {AdministradordemonitoreoModule} from './modules/administradordemonitoreos/administradordemonitoreos.module';
import {ProcesosModule} from './modules/procesos/procesos.module';
import {AsignarProveedorModule} from './modules/asignar-proveedor/asignar-proveedor.module';

const materialModules = [
  MatTableModule,
  MatPaginatorModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatIconModule,
  MatSnackBarModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatSortModule
];

import {PresupuestoModule} from './modules/presupuesto/presupuesto.module';


@NgModule({
  declarations: [AdminDashboardComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ImportsModule,
    VisorModule,
    DiagnosticadorVisorModule,
    CarteraModule,
    SuperadminModule,
    CuotasModule,
    ParametrizacionModule,
    LogisticaModule, 
    VentayaModule,
    ComisionesdevendedoresModule,
    CreditoModule,
    ...materialModules,
    PresupuestoModule,
    ProcesosModule,
    AsignarProveedorModule,
    AdministradordemonitoreoModule
  ]

})
export class AdminModule { }
